import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import HelperS from '../../services/helper.service';
import store from '../../../store';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import { i18n } from '@/i18n';

export default {
  getPipelines(alias, projectAlias, params, branchName, tagName) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline`, {
        params: {
          ...HelperS.getRealPagination(params || {}),
          sort: 'localId,DESC',
          branch: branchName,
          tag: tagName
        }
      })
      .then((res) => {
        store.dispatch('setPipelines', HelperS.parsePagination(res.data));
        store.dispatch('setPipelineIsCreating', false);
        return HelperS.parsePagination(res.data);
      });
  },
  getPipeline(alias, projectAlias, id) {
    return axios.get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}`).then((res) => {
      store.dispatch('setPipeline', res.data);
      return res.data;
    });
  },
  getPipelineStages(alias, projectAlias, id, useStore) {
    useStore = useStore !== undefined ? useStore : true;
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/stage`)
      .then((res) => {
        if (useStore) store.dispatch('setPipelineStages', res.data);
        return res.data;
      });
  },
  getPipelineStageJob(alias, projectAlias, id, stageId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/stage/${stageId}/job`)
      .then((res) => {
        store.dispatch('setPipelineStageJobs', res.data);
        return res.data;
      });
  },
  getPipelineJobs(alias, projectAlias, id, useStore) {
    useStore = useStore !== undefined ? useStore : true;
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/job`)
      .then((res) => {
        if (useStore) store.dispatch('setStageJobs', res.data);
        return res.data;
      });
  },
  startPipeline(alias, projectAlias, data) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/cicd/pipeline/start`, data)
      .then(() => {
        store.dispatch('setPipelineIsCreating', true);
        this.getPipelines(alias, projectAlias, {
          page: HelperS.getQueryParamsFromURL().params.get('page'),
          branch: HelperS.getQueryParamsFromURL().params.get('branch'),
          tag: HelperS.getQueryParamsFromURL().params.get('tag')
        });
      });
  },
  restartPipeline(alias, projectAlias, id) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/restart`, {})
      .then(() =>
        this.getPipelines(alias, projectAlias, {
          page: HelperS.getQueryParamsFromURL().params.get('page'),
          branch: HelperS.getQueryParamsFromURL().params.get('branch'),
          tag: HelperS.getQueryParamsFromURL().params.get('tag')
        })
      );
  },
  cancelPipeline(alias, projectAlias, id) {
    return axios.post(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/cancel`).then(() =>
      this.getPipelines(alias, projectAlias, {
        page: HelperS.getQueryParamsFromURL().params.get('page'),
        branch: HelperS.getQueryParamsFromURL().params.get('branch'),
        tag: HelperS.getQueryParamsFromURL().params.get('tag')
      })
    );
  },
  deletePipeline(alias, projectAlias, id) {
    return axios
      .delete(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/delete`)
      .then(() =>
        this.getPipelines(alias, projectAlias, {
          page: HelperS.getQueryParamsFromURL().params.get('page'),
          branch: HelperS.getQueryParamsFromURL().params.get('branch'),
          tag: HelperS.getQueryParamsFromURL().params.get('tag')
        })
      );
  },
  getStages(alias, projectAlias) {
    return axios.get(`/api/project/${alias}/${projectAlias}/cicd/stages`);
  },
  getJobs(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/job`, {
        params: { ...HelperS.getRealPagination(params), sort: 'id,DESC' }
      })
      .then((res) => {
        store.dispatch('setJobs', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      });
  },
  getJob(alias, projectAlias, id) {
    return axios.get(`/api/project/${alias}/${projectAlias}/cicd/job/${id}`).then((res) => {
      store.dispatch('setJob', res.data);
      return res.data;
    });
  },
  getJobLog(alias, projectAlias, id) {
    return axios.get(`/api/project/${alias}/${projectAlias}/cicd/job/${id}/log`).then((res) => {
      store.dispatch('setJobLog', res.data);
      return res.status;
    }).catch((err) => {
      return err.response.status
    })
  },
  refreshJobLog(alias, projectAlias, id) {
    const storedJobLog = store.getters.getJobLog;
    if (storedJobLog == null) {
      return this.getJobLog(alias, projectAlias, id);
    }
    return axios
      .get(
        `/api/project/${alias}/${projectAlias}/cicd/job/${id}/log?start=${storedJobLog.logModel.totalSize}`
      )
      .then((res) => {
        const fetchedJobLogPatch = res.data;
        if (fetchedJobLogPatch.truncate === true) {
          store.dispatch('setJobLog', fetchedJobLogPatch);
          return;
        }
        if (
          fetchedJobLogPatch.logModel.lines.length === 0 &&
          fetchedJobLogPatch.patching === storedJobLog.patching
        ) {
          return;
        }
        storedJobLog.truncate = true;
        storedJobLog.patching = fetchedJobLogPatch.patching;
        storedJobLog.logModel.lines.push(...fetchedJobLogPatch.logModel.lines);
        storedJobLog.logModel.size += fetchedJobLogPatch.logModel.size;
        storedJobLog.logModel.totalSize = fetchedJobLogPatch.logModel.totalSize;
        store.dispatch('setJobLog', storedJobLog);
      });
  },
  startJob(alias, projectAlias, id) {
    return axios.post(`/api/project/${alias}/${projectAlias}/cicd/job/${id}/restart`, {});
  },
  cancelJob(alias, projectAlias, id) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/cicd/job/${id}/cancel`, {})
      .then((res) => {
        store.dispatch('startJob', res.data);
        return res.data;
      });
  },
  getPipelineFailedJobs(alias, projectAlias, id) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/job/failed`)
      .then((res) => {
        store.dispatch('setPipelineFailedJobs', res.data);
        return res.data;
      });
  },
  getPipelineArtifacts(alias, projectAlias, pipelineId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${pipelineId}/artifact`)
      .then((res) => {
        store.dispatch('setPipelineArtifacts', res.data);
        return res.data;
      });
  },
  getJobArtifacts(alias, projectAlias, jobId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/job/${jobId}/artifact`)
      .then((res) => {
        store.dispatch('setJobArtifacts', res.data);
        return res.data;
      });
  },
  lockJobArtifact(alias, projectAlias, artifact) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/cicd/job/${artifact.job.localId}/artifact/${artifact.id}/lock`
      )
      .then((res) => {
        artifact.isKeep = !artifact.isKeep;
        return res.data;
      });
  },
  deleteJobArtifact(userAlias, projectAlias, artifact) {
    return axios
      .delete(
        `/api/project/${userAlias}/${projectAlias}/cicd/job/${artifact.job.localId}/artifact/${artifact.id}`
      )
      .then(() => {
        smallNotification('success', { title: i18n.t('cicd.artifacts.delete') });
        store.dispatch('deleteArtifact', artifact.id);
      });
  },
  getNeeds(alias, projectAlias, pipelineId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${pipelineId}/needs`)
      .then((res) => {
        store.dispatch('setPipelineNeeds', res.data);
        return res.data;
      });
  },
  deleteJobLog(alias, projectAlias, jobId) {
    return axios.delete(`/api/project/${alias}/${projectAlias}/cicd/job/${jobId}`).then(() => {
      store.dispatch('deleteJobLog');
      this.getJobLog(alias, projectAlias, jobId);
    });
  },
  getMergeRequestActualPipeline(alias, projectAlias, id) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${id}/actual-pipeline`)
      .then((res) => res.data);
  },
  clearPipelinesCache(alias, projectAlias) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/setting/cicd/reset-cache`)
      .then((res) => res.data);
  },
  getFeatureModel(alias, projectAlias) {
    return axios.get(`/project/${alias}/${projectAlias}/ci-cd`);
  },
  getPipelinesSchedules(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/`, {
        params: { ...HelperS.getRealPagination(params || {}), sort: 'id,DESC' }
      })
      .then((res) => {
        store.dispatch('setPipelineSchedules', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      });
  },
  getPipelineScheduleBeforeEdit(alias, projectAlias, scheduleUuid) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/edit/${scheduleUuid}`)
      .then((res) => {
        store.dispatch('setPipelineCurrentSchedule', res.data);
        return res.data;
      });
  },
  getScheduleInfoBeforeCreate(alias, projectAlias) {
    return axios.get(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/create`).then((res) => {
      store.dispatch('setPipelineCurrentSchedule', res.data);
      return res.data;
    });
  },
  createPipelineSchedule(alias, projectAlias, params) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/create`, params, {
        formName: FORM_NAME_ENUMS.PIPELINE_SCHEDULE_FORM
      })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  activatePipelineSchedule(alias, projectAlias, scheduleUuid) {
    return axios
      .put(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/activate/${scheduleUuid}`)
      .then(() => {
        this.getPipelinesSchedules(alias, projectAlias, {
          page: HelperS.getQueryParamsFromURL().params.get('page')
        });
      });
  },
  deactivatePipelineSchedule(alias, projectAlias, scheduleUuid) {
    return axios
      .put(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/deactivate/${scheduleUuid}`)
      .then(() => {
        this.getPipelinesSchedules(alias, projectAlias, {
          page: HelperS.getQueryParamsFromURL().params.get('page')
        });
      });
  },
  deletePipelineSchedule(alias, projectAlias, scheduleUuid) {
    return axios
      .delete(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/delete/${scheduleUuid}`)
      .then(() => {
        store.dispatch('deletePipelineSchedule', scheduleUuid);
        this.getPipelinesSchedules(alias, projectAlias, {
          page: HelperS.getQueryParamsFromURL().params.get('page')
        });
      });
  },
  getScheduleInfoBeforeEdit(alias, projectAlias, scheduleUuid) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/edit/${scheduleUuid}`)
      .then((res) => {
        store.dispatch('setPipelineCurrentSchedule', res.data);
        return res.data;
      });
  },
  editPipelineSchedule(alias, projectAlias, params) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/ci-cd/schedule/edit`, params, {
        formName: FORM_NAME_ENUMS.PIPELINE_SCHEDULE_FORM
      })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  startCommitPipeline(alias, projectAlias, commitId, params) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/ci-cd/action/branch/pipeline-start?commitId=${commitId}`,
        params
      )
      .then((res) => { 
        smallNotification('success', { title: i18n.t('cicd.pipeline.start') });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: i18n.t('message.error_occured') });
        throw err;
      });
  },
  getPipelineUnitTestResult(alias, projectAlias, pipelineId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${pipelineId}/unit-test-result`)
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getJobUnitTestResult(alias, projectAlias, jobId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/job/${jobId}/unit-test-result`)
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getJobUnitTestCaseReports(alias, projectAlias, jobId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/job/${jobId}/test-case-reports`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getPipelineTemplatesList(params) {
    return axios
      .get(`/api/project/create/pipeline-templates`, params)
      .then((res) => {
        store.dispatch('setPipelineTemplatesList', res?.data);
        return res?.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getAdminPipelineTemplatesList(params) {
    return axios
      .get(`/api/admin/project/create/pipeline-templates`, params)
      .then((res) => {
        store.dispatch('setAdminPipelineTemplatesList', res?.data);
        return res?.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getCiCdPipelineTemplatesList(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/pipeline-template/list`, params)
      .then((res) => {
        store.dispatch('setPipelineTemplatesList', res?.data);
        return res?.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getPipelineConfugurationExistence(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/cicd/pipeline/need-configuration`, params)
      .then((res) => {
        store.dispatch('setPipelineConfugurationExistence', !res.data);
        return !res.data;
      })
      .catch((err) => {
        if (err?.response?.status === 404)
          store.dispatch('setPipelineConfugurationExistence', false);
        throw err;
      });
  },
  getPipelineTemplateCommitInfo(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/pipeline-template/default-commit-info`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  commitPipelineTemplate(userAlias, projectAlias, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/pipeline-template/add`, params, {
        formName: FORM_NAME_ENUMS.COMMIT_PIPELINE_TEMPLATE_FORM,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res?.data)
      .catch((err) => {
        throw err;
      });
  },
  getEditorTemplateInfo(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/pipeline-template/editor-template-info`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  retryStages(userAlias, projectAlias, localId, stageUuid) {
    return axios.post(`/api/project/${userAlias}/${projectAlias}/cicd/pipeline/${localId}/stage/${stageUuid}/retry`, {});
  },
  getDownoladStatus(url) {
    return axios
      .get(url)
      .then((res) => {
        return res.status
      })
      .catch((err) => {
        smallNotification('danger', { title: i18n.t('cicd.artifacts.notFound') });
        throw err
      })
  },

  getVariablesPipeline(userAlias, projectAlias, params) {
    store.dispatch('setVariablesLoaderCiCd', true)
    return axios.get(`/api/project/${userAlias}/${projectAlias}/cicd/pipeline/prefilled-variables`, {
      params, 
      timeout: 5000
    }) 
    .then((res) => {
      store.dispatch('setExistingCiCdVariables', {
        formName: FORM_NAME_ENUMS.CI_CD_VARIABLES_PIPELINE_START,
        variables: res.data
      })
      return res.data
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        smallNotification('danger', { title: i18n.t('message.limitExceeded') });
      } else {
        smallNotification('danger', { title: i18n.t('message.error_occured')});
      } 
      throw err
    })
    .finally(() => {
      store.dispatch('setVariablesLoaderCiCd', false)
    })
  },
  
  postVariablesPipeline(userAlias, projectAlias, data) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/cicd/pipeline/start`, data, 
        {
          formName: FORM_NAME_ENUMS.CI_CD_VARIABLES_PIPELINE_START,
        }
      )
      .then((res) => {
        return res.status
      })
      .catch((err) => {
        smallNotification('danger', { title: i18n.t('message.error_occured') });
        throw err
      })
  },

  resetVariableCachePipeline(userAlias, projectAlias, params) {
    return axios
      .delete(`/api/project/${userAlias}/${projectAlias}/cicd/pipeline/prefilled-variables/cache`,
        {
          params
        }
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        smallNotification('danger', { title: i18n.t('message.error_occured') });
        throw err
    })
  } 
};

